import { render, staticRenderFns } from "./CompanyProfilePage.vue?vue&type=template&id=4a21da46&"
import script from "./CompanyProfilePage.vue?vue&type=script&lang=js&"
export * from "./CompanyProfilePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports